import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { Link } from "react-router-dom";

const Header = () => {
    const textStyle = {
        color: 'rgb(138, 224, 102)',
    }
    return (
        < Navbar collapseOnSelect expand="lg" className="menu textColor" variant="dark" >
            <Container>
                <Navbar.Brand as={Link} to="/" className='textColor' >Rafiq Ahamed Tanim (<span className='textColor'>OakFrog</span>)</Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="ms-auto" >
                        <Nav.Link as={Link} to="/about-me" style={textStyle}>About</Nav.Link>
                        <Nav.Link as={Link} to="/projects" style={textStyle}>Projects</Nav.Link>
                        <Nav.Link as={Link} to="/contact" style={textStyle}>Contact</Nav.Link>
                        {/* <Nav.Link href="#contact">Contact</Nav.Link> */}
                        <Nav.Link as={Link} to="/blogs" style={textStyle}>Blogs</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar >
    );
};

export default Header;